// local host
export const SERVER_LINK = "http://3.6.252.9:3005/api";
// export const SERVER_LINK = "http://localhost:5000/api";


// dev
// export const SERVER_LINK = "";

// prod
// export const SERVER_LINK = "";
